(function () {
  'use strict';

  console.log('Here in language transformation CZ -> DE');

  var ROOT_SELECTORS =
    '.cus-variant-table-wrapp, ' +
    '.blog__tag-item, ' +
    '.blog__tag-current, ' +
    '.info-box, ' +
    '.comparison-table, ' +
    '.cart-drawer, ' +
    '.collapsible-tabs-section-heading, ' +
    '.footer-link, ' +
    '.blog__post-tags-link, ' +
    '.product__selectors, ' +
    ".selected-option-value, " +
    '.navlink, ' +
    '.column-item__heading';

  // Czech/source text -> German dictionary
  var dict = {
    'Препоръчай и вземи': '',
    'Umtausch & Rückgabe': '',

    'Tenkostěnná litina':
      'Dünnwandiges Gusseisen',

    'Představujeme netoxické materiály':
      'Wir stellen ungiftige Materialien vor',

    'След като стойността на поръчката ви достигне 3500 чешки крони, доставката е безплатна.':
      'Ab einem Bestellwert von 145 EUR ist der Versand kostenlos.',

    'Nepřilnavost':
      'Antihaftwirkung',

    'Titanový smalt je oproti běžnému smaltu výrazně nepřilnavější. Nerez bez povlaku má horší nepřilnavost.':
      'Titanemaille ist im Vergleich zu herkömmlicher Emaille deutlich antihaftender. Unbeschichteter Edelstahl hat schlechtere Antihafteigenschaften.',

    'Tepelná vodivost':
      'Wärmeleitfähigkeit',
    "V případě zvláštních požadavků k objednávce nás prosím kontaktujte na emailovou adresu info@huuust.cz, nebo telefonicky na číslo +420 604 570 519.": "Bei besonderen Wünschen zu Ihrer Bestellung kontaktieren Sie uns bitte per E-Mail unter info@huuust.cz oder telefonisch unter +420 604 570 519.",
    'Jak rychle a rovnoměrně se materiál zahřívá - nerez s hliníkovým jádrem je nejeefektivnější.':
      'Wie schnell und gleichmäßig sich das Material erwärmt – Edelstahl mit Aluminiumkern ist am effizientesten.',

    'Udržení teploty':
      'Wärmespeicherung',

    'Schopnost materiálu držet teplotu – důležité při dušení a servírování. Litina vyniká.':
      'Die Fähigkeit des Materials, die Temperatur zu halten – wichtig beim Schmoren und Servieren. Gusseisen zeichnet sich hier besonders aus.',

    'Odolnost proti poškození. Smalt se může odštípnout, titanový smalt je pevnější. Nerez se může lehce deformovat.':
      'Widerstandsfähigkeit gegen Beschädigungen. Emaille kann abplatzen, Titanemaille ist robuster. Edelstahl kann sich leicht verformen.',

    'Snadnost údržby':
      'Pflegeleichtigkeit',

    'Možnost mytí v myčce. Nerez je bez problémů, litinu doporučujeme mýt ručně.':
      'Spülmaschinengeeignet. Edelstahl ist problemlos spülmaschinenfest, Gusseisen empfehlen wir von Hand zu spülen.',

    'Indukce':
      'Induktion',

    'Odolnost':
      'Widerstandsfähigkeit',

    'Kompatibilita s indukcí – všechny tři materiály jsou vhodné.':
      'Induktionskompatibilität – alle drei Materialien sind geeignet.',

    'Hmotnost a manipulace – tenká litina je o 50 % lehčí než klasická, nerez nejlehčí.':
      'Gewicht und Handhabung – dünnwandiges Gusseisen ist 50 % leichter als klassisches Gusseisen, Edelstahl ist am leichtesten.',

    'Průměr dna':
      'Bodendurchmesser',

    'Design od':
      'Design von',

    'NÁDOBÍ S DNA':
      'KOCHGESCHIRR MIT DER DNA DES',

    'AUTOMOTIVE':
      'AUTOMOBILBAUS',

    'OVĚŘENO':
      'ERPROBT VON',

    'ŠÉFKUCHAŘI':
      'SPITZENKÖCHEN',

    'Průměr okrajů':
      'Randdurchmesser',

    'Rozměry':
      'Abmessungen',

    'Objem':
      'Volumen',
      "Huuust oranžová": "Huuust-Orange",
"Matná černá": "Mattschwarz",
"Perlově šedá": "Perlgrau",
"Granátově červená": "Granatrot",
"Safírově modrá": "Saphirblau",
"Pastelově modrá": "Pastellblau",
"Pastelově žlutá": "Pastellgelb",
"Pastelově oranžová": "Pastellorange",

    'Hmotnost':
      'Gewicht',

    'Barva':
      'Farbe',

    'Materiál':
      'Material',

    'Litina':
      'Gusseisen',

    'Plody moře':
      'Meeresfrüchte',

    'Dárky':
      'Geschenke',

    'Inspirace':
      'Inspiration',

    'Non-toxic':
      'Ungiftig',

    'Udržitelnost':
      'Nachhaltigkeit',

    'Nerezové nádobí':
      'Edelstahlkochgeschirr',

    'Nože':
      'Messer',

    'Smaltované nádobí':
      'Emailliertes Kochgeschirr',

    'Tipy':
      'Tipps',

    'Zajímavosti':
      'Wissenswertes',

    'Dezert':
      'Dessert',

    'Dušení':
      'Schmoren',

    'Hovězí':
      'Rindfleisch',

    'Kuřecí':
      'Hähnchen',

    'Ovoce':
      'Obst',

    'Pečení':
      'Backen',

    'Smažení':
      'Braten',

    'Vaření':
      'Kochen',

    'Vepřové':
      'Schweinefleisch',

    'Zelenina':
      'Gemüse',

    'kategorie':
      'Kategorie',

    'Images':
      'Bilder',

    'Dostupnost':
      'Verfügbarkeit',

    'Google: Condition':
      'Google: Zustand',

    'Google: MPN':
      'Google: MPN',

    'Google: Gender':
      'Google: Geschlecht',

    'Google: Size Type':
      'Google: Größentyp',

    'Google: Size System':
      'Google: Größensystem',

    'Google: Age Group':
      'Google: Altersgruppe',

    'Poklice součástí balení':
      'Deckel im Lieferumfang enthalten',

    'Google: Custom Label 0':
      'Google: Benutzerdefiniertes Label 0',

    'Google: Custom Label 1':
      'Google: Benutzerdefiniertes Label 1',

    'Google: Custom Label 2':
      'Google: Benutzerdefiniertes Label 2',

    'Google: Custom Label 3':
      'Google: Benutzerdefiniertes Label 3',

    'Objednáš, vyzkoušíš, v klidu vrátíš':
      'Bestellen, ausprobieren und ganz entspannt zurückgeben',

    'Další informace':
      'Weitere Informationen',

    'Vlastnost':
      'Eigenschaft',

    'Vysvětlivka':
      'Erläuterung',

    'Zahřívání':
      'Erwärmung',

    'Reakce na teplotu':
      'Temperaturreaktion',

    'Údržba':
      'Pflege',

    'Použití':
      'Verwendung',

    'Pro koho je':
      'Geeignet für',

    'Surová litina':
      'Unbeschichtetes Gusseisen',

    'Těžší, robustní':
      'Schwerer und robust',

    'Zahřívá se pomaleji':
      'Erwärmt sich langsamer',

    'Pomalejší změny':
      'Langsamere Temperaturänderungen',

    'Často vyžaduje více péče':
      'Erfordert häufig mehr Pflege',

    'Skvělé na dlouhé dušení a pečení':
      'Ideal für langes Schmoren und Backen',

    'Pro milovníky tradiční litiny a pomalého vaření':
      'Für Liebhaber von traditionellem Gusseisen und langsamem Garen',

    'Lehčí, snadnější manipulace':
      'Leichter und einfacher zu handhaben',

    'Zahřívá se rychleji':
      'Erwärmt sich schneller',

    'Pohotovější při vaření':
      'Reagiert beim Kochen schneller',

    'Bez seasoning a bez rituálů':
      'Kein Einbrennen und keine besonderen Pflegerituale erforderlich',

    'Индукция i trouba, ideální i na každý den':
      'Für Induktion und Backofen geeignet, ideal für den täglichen Gebrauch',

    'Pro každodenní vaření i náročnější recepty':
      'Für das tägliche Kochen und anspruchsvollere Rezepte',
    "Součet": "Summe",
    "Celkově ušetřeno": "Insgesamt gespart"
  };

  var keys = Object.keys(dict);

  function replaceInTextNode(node) {
    var text = node.nodeValue;

    if (!text) {
      return;
    }

    var changed = false;

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (text.indexOf(key) !== -1) {
        text = text.split(key).join(dict[key]);
        changed = true;
      }
    }

    if (changed) {
      node.nodeValue = text;
    }
  }

  function walkAndReplace(container) {
    var walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) {
            return NodeFilter.FILTER_REJECT;
          }

          var parent = node.parentNode;

          if (!parent) {
            return NodeFilter.FILTER_REJECT;
          }

          var tag = (parent.nodeName || '').toLowerCase();

          if (
            tag === 'script' ||
            tag === 'style' ||
            tag === 'noscript'
          ) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var node;

    while ((node = walker.nextNode())) {
      replaceInTextNode(node);
    }
  }

  function run() {
    // Re-query the elements because Shopify may inject them later.
    var roots = document.querySelectorAll(ROOT_SELECTORS);

    if (!roots.length) {
      return;
    }

    roots.forEach(function (element) {
      walkAndReplace(element);
    });
  }

  // Run once after the DOM is ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Observe dynamic updates inside the matching Shopify elements.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === 'characterData') {
        replaceInTextNode(mutation.target);
      } else if (
        mutation.addedNodes &&
        mutation.addedNodes.length
      ) {
        for (
          var j = 0;
          j < mutation.addedNodes.length;
          j++
        ) {
          var addedNode = mutation.addedNodes[j];

          if (addedNode.nodeType === 3) {
            replaceInTextNode(addedNode);
          } else if (addedNode.nodeType === 1) {
            walkAndReplace(addedNode);
          }
        }
      }
    }
  });

  function startObserver() {
    var roots = document.querySelectorAll(ROOT_SELECTORS);

    if (!roots.length) {
      return false;
    }

    roots.forEach(function (element) {
      observer.observe(element, {
        subtree: true,
        childList: true,
        characterData: true
      });
    });

    return true;
  }

  if (!startObserver()) {
    // Retry briefly for content loaded after initial rendering.
    var tries = 0;

    var timer = setInterval(function () {
      tries++;
      run();

      if (startObserver() || tries > 20) {
        clearInterval(timer);
      }
    }, 500);
  }
})();